export const SET_IS_DIAGNOSTIC_FLOW = 'app/advancedDiagnostic/SET_IS_DIAGNOSTIC_FLOW';
export const SET_DIAGNOSTIC_FLOW_DEVICE_DATA_COLLECTION_IN_PROGRESS =
    'app/advancedDiagnostic/SET_DIAGNOSTIC_FLOW_DEVICE_DATA_COLLECTION_IN_PROGRESS';
export const SET_DIAGNOSTIC_FLOW_DATA_RESULT = 'app/advancedDiagnostic/SET_DIAGNOSTIC_FLOW_DATA_RESULT';
export const CLEAR_ADVANCED_DIAGNOSTIC_STATE = 'app/advancedDiagnostic/CLEAR_ADVANCED_DIAGNOSTIC_STATE';
export const SET_FAILED_ATTEMPS = 'app/advancedDiagnostic/SET_FAILED_ATTEMPS';
export const SET_IS_PHASE_2 = 'app/advancedDiagnostic/SET_IS_PHASE_2';

const initialState = {
    isDiagnosticFlow: false,
    isDiagnosticFlowDataCollectionInProgress: false,
    diagnosticFlowDataResult: undefined,
    failedAttempts: undefined,
    isPhase2: undefined,
};

export default function reducer(state = initialState, action) {
    const {type} = action;

    switch (type) {
        case CLEAR_ADVANCED_DIAGNOSTIC_STATE: {
            return {...initialState, isPhase2: state.isPhase2};
        }
        case SET_IS_DIAGNOSTIC_FLOW: {
            return {
                ...state,
                isDiagnosticFlow: action.payload,
            };
        }
        case SET_DIAGNOSTIC_FLOW_DEVICE_DATA_COLLECTION_IN_PROGRESS: {
            return {
                ...state,
                isDiagnosticFlowDataCollectionInProgress: action.payload,
            };
        }
        case SET_DIAGNOSTIC_FLOW_DATA_RESULT: {
            return {
                ...state,
                diagnosticFlowDataResult: action.payload,
            };
        }
        case SET_FAILED_ATTEMPS: {
            return {
                ...state,
                failedAttempts: action.payload,
            };
        }
        case SET_IS_PHASE_2: {
            return {
                ...state,
                isPhase2: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}

export const setIsDiagnosticFlow = (data) => ({
    type: SET_IS_DIAGNOSTIC_FLOW,
    payload: data,
});

export const setDiagnosticFlowDataCollectionInProgress = (data) => ({
    type: SET_DIAGNOSTIC_FLOW_DEVICE_DATA_COLLECTION_IN_PROGRESS,
    payload: data,
});

export const setDiagnosticFlowDataResult = (data) => ({
    type: SET_DIAGNOSTIC_FLOW_DATA_RESULT,
    payload: data,
});

export const clearAdvancedDiagnosticState = () => ({
    type: CLEAR_ADVANCED_DIAGNOSTIC_STATE,
});

export const setFailedAttempts = (data) => ({
    type: SET_FAILED_ATTEMPS,
    payload: data,
});

export const setIsDiagnosticPhase2 = (data) => ({
    type: SET_IS_PHASE_2,
    payload: data,
});
